
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/events",
      function () {
        return require("private-next-pages/[region]/[language]/events/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/events"])
      });
    }
  